import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CharterNavComponent } from './charter-nav.component';
import { NavProfileMenuComponent } from './nav-popover/nav-popover';

@NgModule({
  declarations: [CharterNavComponent, NavProfileMenuComponent],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [CharterNavComponent, NavProfileMenuComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CharterNavModule {}
